import { BitfPResponseMapper } from '@bitf/core/parsers/p-parser';

export class AppResponseMapper extends BitfPResponseMapper {}
